module.exports = __webpack_public_path__ + "static/media/agri-retailers-challenges.055d95f2.png";